import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import usersIcon from '@mui/icons-material/AccountCircle';
import { LAYOUT_ROUTES } from 'routes';
export const SuperAdminRouter = [
    {
        name: 'Applicants',
        url: LAYOUT_ROUTES.BUSINESSES,
        icon: CheckCircleOutlineIcon
    },
    {
        name: 'Customers',
        url: LAYOUT_ROUTES.CUSTOMERS,
        icon: usersIcon
    }
];

export const AdminRouteSidebar = [
    {
        name: 'Overview',
        url: LAYOUT_ROUTES.OVERVIEW,
        icon: DashboardOutlinedIcon
    },
    {
        name: 'Cards',
        url: LAYOUT_ROUTES.CARDS,
        icon: CreditCardOutlinedIcon
    },
    {
        name: 'Transactions',
        url: LAYOUT_ROUTES.TRANSACTIONS,
        icon: PaymentsOutlinedIcon
    },
    {
        name: 'Users',
        url: LAYOUT_ROUTES.USERS,
        icon: AccountCircleOutlinedIcon
    },
    {
        name: 'Bitcoin Rewards',
        url: LAYOUT_ROUTES.REWARDS,
        icon: EmojiEventsOutlinedIcon
    }
];

export const UserRouteSidebar = [
    {
        name: 'Cards',
        url: LAYOUT_ROUTES.CARDS,
        icon: CreditCardOutlinedIcon
    },
    {
        name: 'Transactions',
        url: LAYOUT_ROUTES.TRANSACTIONS,
        icon: PaymentsOutlinedIcon
    },
    {
        name: 'Rewards',
        url: LAYOUT_ROUTES.REWARDS,
        icon: EmojiEventsOutlinedIcon
    }
];

export const GiftUserRouteSidebar = [
    {
        name: 'Cards',
        url: LAYOUT_ROUTES.CARDS,
        icon: CreditCardOutlinedIcon
    },
    {
        name: 'Transactions',
        url: LAYOUT_ROUTES.TRANSACTIONS,
        icon: PaymentsOutlinedIcon
    }
];
